import { createFileRoute } from "@tanstack/react-router";
import ResidentCarePage from "@project/user/pages/care/resident-care";

export const Route = createFileRoute("/_user/_care/resident-care")({
  head: () => ({
    meta: [
      { title: "Resident Care — Jivandhara" },
      {
        name: "description",
        content:
          "What life is like at Jivandhara: shelter, food, medical and emotional care.",
      },
    ],
  }),
  component: ResidentCarePage,
});
